import { isFunction } from '@dimjs/lang';
import { valueIsEqual } from '@flatbiz/utils';
import { dialogPageSpinner } from '../dialog';
import { dialogPageError } from '../page-error';
import { PageErrorProps } from '../page-error/page-error';
import { useEffectCustomAsync } from './use-effect-custom-async';

export type pageInitRequestOptions = {
  getPageErrorContainer?: () => Element | null;
  pageErrorProps?: Omit<PageErrorProps, 'message'>;
};

/**
 * 页面初始化请求结构
 * @param onRequest 返回值为promise的函数
 * ```
 * 1. onRequest返回resolve，会执行dialogPageSpinner.hide操作
 * 2. onRequest返回reject，会显示页面异常效果
 * 3. getPageErrorContainer配置异常页面渲染父级
 *
 * 可配置window参数
 * 1. _account_error = {
 *  btnName: 按钮名称，默认值：重新登录
 *  btnType: button类型
 *  btnFill: button填充模式
 *  code: 账户异常code码，数组格式,
 *  logout: 点击登录按钮事件，函数类型
 * }
 * ```
 */
export const usePageInitRequest = (onRequest: () => Promise<any>, options?: pageInitRequestOptions) => {
  useEffectCustomAsync(async () => {
    try {
      await onRequest();
      dialogPageSpinner.hide();
    } catch (error) {
      const pageErrorProps = options?.pageErrorProps || {};
      const accountError = window['_account_error'];
      const buttonProps = pageErrorProps.buttonProps || {};
      if (accountError.btnType) {
        buttonProps.type = accountError.btnType;
      }
      if (accountError.btnFill) {
        buttonProps.fill = accountError.btnFill;
      }
      if (valueIsEqual(error?.code, accountError?.code || [])) {
        const logout = accountError?.logout;
        pageErrorProps.btnName = accountError?.btnName || '重新登录';
        buttonProps.onClick = isFunction(logout) ? logout : undefined;
      }
      pageErrorProps.buttonProps = buttonProps;
      dialogPageError.show({
        message: error.message,
        ...pageErrorProps,
        getContainer: options?.getPageErrorContainer,
      });
      dialogPageSpinner.hide();
    }
  }, []);
};
